<template>
  <div class="contact-page">
    <PageBanner
      title="Contact Us"
      subtitle="Have questions about the real estate market? We're here to provide expert guidance and support."
      :bannerImage="'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1600'"
    />

    <ContactForm />
  </div>
</template>

<script setup>
import PageBanner from '@/components/PageBanner.vue';
import ContactForm from '@/components/ContactForm.vue';
</script>

<style scoped>
.contact-page {
  background: #fff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.contact-content-area {
  padding: 100px 0;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 80px;
  align-items: start;
}

.section-intro {
  margin-bottom: 40px;
}

.tag {
  color: #b91c1c;
  font-weight: 800;
  font-size: 0.85rem;
  letter-spacing: 2px;
}

.section-intro h2 {
  font-size: 2.8rem;
  margin: 15px 0;
  color: #111;
  font-weight: 800;
}

.section-intro p {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
}

/* Sidebar Styling */
.info-card {
  background: #111;
  color: white;
  padding: 45px;
  border-radius: 4px;
  margin-bottom: 30px;
}

.info-card h3 {
  font-size: 1.6rem;
  margin-bottom: 40px;
  font-weight: 800;
  position: relative;
}

.info-card h3::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 40px;
  height: 2px;
  background: #b91c1c;
}

.sidebar-links {
  display: flex;
  flex-direction: column;
  gap: 35px;
}

.detail-item {
  display: flex;
  gap: 20px;
  text-decoration: none;
  color: white;
  transition: all 0.3s ease;
}

.detail-item:hover {
  transform: translateX(10px);
}

.icon-box {
  background: rgba(185, 28, 28, 0.15);
  color: #b91c1c;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  flex-shrink: 0;
  border: 1px solid rgba(185, 28, 28, 0.3);
}

.detail-item small {
  display: block;
  color: #b91c1c;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1px;
  margin-bottom: 6px;
}

.detail-item p {
  font-size: 1.05rem;
  line-height: 1.5;
  margin: 0;
  color: #ccc;
}

.map-container {
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #eee;
}

/* Responsive Styles */
@media (max-width: 1024px) {
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 60px;
  }

  .info-card {
    order: -1; /* Puts info above form on tablets */
  }
}

@media (max-width: 768px) {
  .section-intro h2 {
    font-size: 2.2rem;
  }

  .contact-content-area {
    padding: 60px 0;
  }
}
</style>
